import React, { useState, useEffect } from "react";
// import Modal from "react-modal";
import Joi from "joi";
import "./CreateTenant.css";
import { FaCheckCircle, FaInfoCircle } from "react-icons/fa";
import { Loader as LoaderIcon } from "react-feather";

import useCreateTenantModal from "../../customHooks/CreateTenantModal/useCreateTenantModal";
import { Modal } from "react-bootstrap";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";

const CreateTenantModal = ({
  isOpen,
  onRequestClose,
  setCurrentPage,
  setSearchTerm,
  fetchTenants,
  tenantsPerPage,
  excludeInactive,
}) => {
  const {
    currentStep,
    plans,
    formData,
    errors,
    handleChange,
    handlePlanSelection,
    handleSubscriptionTypeSelection,
    getPlanPrice,
    nextStep,
    prevStep,
    handleFormSubmit,
    handleFileChange,
    setFormData,
    selectOptions,
    getFieldDescription,
    isStandard,
    setIsStandard,
    setCurrentStep,
    handleFormSkip,
    submitLoader,
    skipLoader,
    customLoader,
    totalSteps,
  } = useCreateTenantModal({
    isOpen,
    onRequestClose,
    setCurrentPage,
    setSearchTerm,
    fetchTenants,
    tenantsPerPage,
    excludeInactive,
  });

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div>
            <h2 className="text-lg font-semibold mb-2">Merchant Information</h2>
            <div className="form-box">
              <div className="form-group">
                <label className="block">
                  User Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="userName"
                  value={formData.userName}
                  onChange={handleChange}
                />
                {errors.userName && (
                  <p className="text-red-500">{errors.userName}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="text-red-500">{errors.email}</p>}
              </div>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={nextStep}
              >
                Next →
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <h2 className="text-lg  mb-4">Store Information</h2>
            <div className="grid grid-cols-3 gap-4">
              {selectOptions.storeTypes.map((cate) => (
                <div
                  key={cate.iTypeId}
                  className={`${
                    formData.storeType === cate.name
                      ? "border-blue-500 bg-blue-50"
                      : "border-gray-300"
                  } modalimg`}
                  onClick={() =>
                    setFormData({
                      ...formData,
                      storeType: cate.name,
                      storeConfigKeys: cate.configurationKeys,
                      storeTypeId: cate.iStoreTypeId || "",
                    })
                  }
                >
                  <img
                    src={cate.logo}
                    alt={cate.name}
                    className={`object-contain modalimgs`}
                  />
                  <p className="text-center py-2 font-medium">{cate.name}</p>
                </div>
              ))}

              <div className="border-gray-300 bg-gray-100 modalimg opacity-50 cursor-not-allowed">
                <img
                  src="https://dx2ctuk6q6hvo.cloudfront.net/uploads/2024-09-02/Image-1725270402477-735725891"
                  alt="Magento"
                  className="object-contain modalimgs"
                />
                <p className="text-center py-2 font-medium">Magento</p>
              </div>

              <div className="border-gray-300 bg-gray-100 modalimg opacity-50 cursor-not-allowed">
                <img
                  src="https://dx2ctuk6q6hvo.cloudfront.net/uploads/Image-1726464312627-88564457.webp"
                  alt="Custom"
                  className="object-contain modalimgs"
                />
                <p className="text-center py-2 font-medium">Custom</p>
              </div>
              {errors.sStoreType && (
                <p className="text-red-500">{errors.sStoreType}</p>
              )}
            </div>
            <div className="form-box">
              <div className="form-group">
                <label className="block">Store Name</label>
                <input
                  type="text"
                  name="storeName"
                  value={formData.storeName}
                  onChange={handleChange}
                />
                {errors.storeName && (
                  <p className="text-red-500">{errors.storeName}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">Brand Logo</label>
                <input
                  type="file"
                  name="brandLogo"
                  // value={formData.brandLogo}
                  onChange={handleFileChange}
                />
                {errors.brandLogo && (
                  <p className="text-red-500">{errors.brandLogo}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">Currency Type</label>
                <select
                  name="iCurrencyId"
                  value={formData.iCurrencyId}
                  onChange={handleChange}
                >
                  <option value={""}>Select Option</option>
                  {selectOptions?.currency?.map((currency) => {
                    return (
                      <option value={currency.iCurrencyId}>
                        {currency.sName}({currency.sCode})
                      </option>
                    );
                  })}
                </select>

                {errors.currency && (
                  <p className="text-red-500">{errors.currency}</p>
                )}
              </div>
              {formData.storeConfigKeys.map((field) => {
                const fieldName = field.sKey;
                const formattedLabel = fieldName
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase());

                return (
                  <div className="form-group" key={fieldName}>
                    <label className=" flex items-center gap-1">
                      {formattedLabel}
                      <div className="relative group">
                        <span className="cursor-pointer">
                          <FaInfoCircle />
                        </span>
                        <span className="absolute left-6 text-nowrap -top-1 bg-gray-800 text-white text-xs p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                          {getFieldDescription(fieldName)}
                        </span>
                      </div>
                    </label>
                    <input
                      type="text"
                      name={field.sKey}
                      value={formData[field.sKey] || ""}
                      onChange={handleChange}
                      className="border p-2 w-full"
                    />
                    {errors[fieldName] && (
                      <p className="text-red-500">{errors[fieldName]}</p>
                    )}
                  </div>
                );
              })}
              {/* <div className="form-group">
                <label className="block">Store URL</label>
                <input
                  type="text"
                  name="storeUrl"
                  value={formData.storeUrl}
                  onChange={handleChange}
                />
                {errors.storeUrl && (
                  <p className="text-red-500">{errors.storeUrl}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">Version </label>
                <input
                  type="text"
                  name="version"
                  value={formData.version}
                  onChange={handleChange}
                />
                {errors.version && (
                  <p className="text-red-500">{errors.version}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">Access Token</label>
                <input
                  type="text"
                  name="accessToken"
                  value={formData.accessToken}
                  onChange={handleChange}
                />
                {errors.accessToken && (
                  <p className="text-red-500">{errors.accessToken}</p>
                )}
              </div>
              <div className="form-group">
                <label className="block">API Key</label>
                <input
                  type="text"
                  name="apiKey"
                  value={formData.apiKey}
                  onChange={handleChange}
                />
                {errors.apiKey && (
                  <p className="text-red-500">{errors.apiKey}</p>
                )}
              </div> */}
            </div>
            <div className="flex justify-between">
              <button
                className="bg-gray-300 text-black px-4 py-2 rounded"
                onClick={prevStep}
              >
                ← Previous
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={nextStep}
              >
                Next →
              </button>
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <h2 className="text-lg font-semibold">Choose a Billing Cycle</h2>
            <div className="p-6 max-w-3xl mx-auto">
              <div className="flex flex-wrap justify-center gap-4 mb-6">
                {plans.map((cycle) => (
                  <button
                    key={cycle.iBillingCycleId}
                    className={`px-4 py-1 rounded-lg text-lg font-medium border transition duration-300 ease-in-out 
                                ${
                                  formData.subscriptionType ===
                                  cycle.iBillingCycleId
                                    ? "bg-blue-600 text-white border-blue-600 shadow-lg transform scale-105"
                                    : "bg-white text-gray-700 border-gray-300 hover:bg-blue-100 hover:border-blue-500"
                                }`}
                    onClick={() =>
                      handleSubscriptionTypeSelection(cycle.iBillingCycleId)
                    }
                  >
                    {cycle.billingCycleName}
                  </button>
                ))}
              </div>
              {/* <p className=" text-lg text-center mb-2">
                Renewal Type:{" "}
                {
                  plans.find(
                    (cycle) =>
                      cycle.iBillingCycleId === formData.subscriptionType
                  )?.sRenewalType
                }
              </p> */}
              <div className="form-group">
                <label>Plan Type</label>
                <select
                  name="isStandard"
                  value={isStandard}
                  onChange={setIsStandard}
                >
                  <option value={"standard"}>Standard</option>
                  <option value={"custom"}>Custom</option>
                </select>
              </div>
              {formData.subscriptionType && (
                <>
                  {!customLoader ? (
                    <div className="grid grid-cols-2 gap-6">
                      {plans
                        .find(
                          (cycle) =>
                            cycle.iBillingCycleId === formData.subscriptionType
                        )
                        ?.plans.map((plan) => {
                          const isSelected =
                            parseInt(formData?.selectedPlan) ===
                            plan.iPlanVersionId;
                          const features = [
                            {
                              sFieldName: "Product Count",
                              sFieldType: "int",
                              sValue: "50",
                            },
                            {
                              sFieldName: "TryOn Count",
                              sFieldType: "int",
                              sValue: "200",
                            },
                            {
                              sFieldName: "Analytics Level",
                              sFieldType: "dropdown",
                              sValue: "Basic",
                            },
                            {
                              sFieldName: "Support Level",
                              sFieldType: "dropdown",
                              sValue: "Email & call support",
                            },
                          ];
                          return (
                            <div
                              key={plan.iPlanVersionId}
                              className={`border rounded-lg p-6 shadow-md cursor-pointer transition-all ${
                                isSelected
                                  ? "border-blue-500 bg-blue-100 scale-105"
                                  : "border-gray-300"
                              }`}
                              onClick={() =>
                                handlePlanSelection(plan.iPlanVersionId)
                              }
                            >
                              {/* Plan Title */}
                              <h4 className="text-xl font-semibold">
                                {plan.planName}
                              </h4>

                              {/* Plan Price */}
                              <div className="flex justify-between items-center mt-2">
                                <span className="text-lg font-bold">
                                  {plan.sSymbol}
                                  {plan.dPrice}/mo
                                </span>
                                {isSelected && (
                                  <FaCheckCircle className="text-green-600 text-2xl" />
                                )}
                              </div>

                              {/* Plan Features */}
                              <div className="mt-4 space-y-2">
                                {plan.Features.map((feature, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center gap-2 text-gray-700"
                                  >
                                    <FaCheckCircle className="text-green-500 text-sm" />

                                    <span className="text-sm">
                                      {feature.sFieldType === "int" ? (
                                        <>
                                          {" "}
                                          {"Upto "}
                                          {feature.sValue}{" "}
                                          <strong>{feature.sFieldName}</strong>{" "}
                                        </>
                                      ) : (
                                        <>
                                          <strong>{feature.sFieldName}:</strong>{" "}
                                          {feature.sValue}
                                        </>
                                      )}
                                    </span>
                                  </div>
                                ))}
                              </div>

                              {/* Select Button */}
                              <button
                                className={`mt-4 w-full py-2 rounded-lg text-white ${
                                  isSelected
                                    ? "bg-green-600"
                                    : "bg-black hover:bg-gray-800"
                                }`}
                              >
                                {isSelected ? "Current Plan" : "Choose Plan"}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <FullPageLoading />
                  )}
                </>
              )}

              {/* {formData?.selectedPlan && (
                <div className="mt-4 text-center">
                  <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                    Proceed with Selected Plan
                  </button>
                </div>
              )} */}
            </div>
            {errors.selectedPlan && (
              <p className="text-red-500">{errors.selectedPlan}</p>
            )}

            <div className="flex justify-between">
              <button
                className="bg-gray-300 text-black px-4 py-2 rounded"
                onClick={prevStep}
              >
                ← Previous
              </button>
              <div className="flex gap-4">
                {/* {skipLoader ? (
                  <button
                    className="save-button"
                    style={{ width: "100px" }}
                    disabled={skipLoader}
                  >
                    <LoaderIcon size={20} className="indicator" />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="save-button"
                    disabled={skipLoader}
                    onClick={handleFormSkip}
                  >
                    Skip and Create
                  </button>
                )} */}
                {submitLoader ? (
                  <button
                    className="save-button"
                    style={{ width: "100px" }}
                    disabled={submitLoader}
                  >
                    <LoaderIcon size={20} className="indicator" />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="save-button"
                    disabled={submitLoader}
                    onClick={handleFormSubmit}
                  >
                    Finish
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        onRequestClose();
        setCurrentStep(1);
        setFormData({
          userName: "",
          email: "",
          phone: "",
          storeName: "",
          store_url: "",
          storeType: "",
          storeTypeId: "",
          subscriptionType: "Monthly",
          selectedPlan: "",
          api_version: "",
          access_token: "",
          brandLogo: null,
          iCurrencyId: "",
          storeConfigKeys: [],
          selectedPlan: "",
        });
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <h2 className="text-2xl font-semibold">Merchant Registration</h2>
      </Modal.Header>
      <Modal.Body>
        <div className="flex items-center justify-between mb-6">
          {[1, 2, 3].map((step) => (
            <div key={step} className="flex items-center w-full">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full text-white font-semibold transition-all 
                ${step <= currentStep ? "bg-blue-500" : "bg-gray-300"}`}
              >
                {step}
              </div>
              {step !== totalSteps && (
                <div
                  className={`flex-1 h-1 transition-all 
                  ${step < currentStep ? "bg-blue-500" : "bg-gray-300"}`}
                ></div>
              )}
            </div>
          ))}
        </div>

        <div className="relative">{renderStepContent()}</div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateTenantModal;
{
  /* <Modal
  isOpen={isOpen}
  onRequestClose={onRequestClose}
  contentLabel="Tenant Registration"
  className="tenantModal"
  overlayClassName="modal-overlay"
  ariaHideApp={false}
  size="lg"
>
  <div className="relative">
    <button
      className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
      onClick={onRequestClose}
    >
      ✕
    </button>
    {renderStepContent()}
  </div>
</Modal>; */
}
